export default {
    url: '/view/:id',
    template: '<user-competence-skill-view skill="vm.skill"/>',
    resolve: {
        skill (SkillResource, $stateParams) {
            return SkillResource.get({ id: $stateParams.id, expand: 'parentSkill' }).$promise;
        }
    },
    controller (skill) {
        this.skill = skill;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/skill/view/index.js